import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const NetworkSetup = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Network Setup & Configuration</h1>
            <p className="service-description">
              Comprehensive network setup and configuration services to ensure seamless connectivity 
              and optimal performance across your organization.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Network Solutions We Provide</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🌐</div>
                    <h3>LAN/WAN Setup</h3>
                  </div>
                  <p>Complete local and wide area network setup with proper routing, switching, and security configurations.</p>
                  <div className="feature-popover">
                    <div className="popover-title">LAN/WAN Setup</div>
                    <ul className="popover-list">
                      <li>Router, switch and VLAN configuration</li>
                      <li>Static/DHCP addressing and subnet design</li>
                      <li>Inter‑VLAN routing and ACL policies</li>
                      <li>ISP handoff and failover setup</li>
                      <li>Structured cabling and patching</li>
                      <li>Documentation and topology diagrams</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">📶</div>
                    <h3>WiFi Configuration</h3>
                  </div>
                  <p>Professional wireless network setup with optimal coverage, security protocols, and guest access management.</p>
                  <div className="feature-popover">
                    <div className="popover-title">WiFi Configuration</div>
                    <ul className="popover-list">
                      <li>AP placement survey and heatmaps</li>
                      <li>SSID design, WPA2/WPA3 and 802.1X</li>
                      <li>Guest network isolation and captive portal</li>
                      <li>Channel planning and band steering</li>
                      <li>Controller or cloud‑managed WiFi setup</li>
                      <li>Roaming optimization and QoS</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔒</div>
                    <h3>Network Security</h3>
                  </div>
                  <p>Implementation of firewalls, VPNs, and network monitoring systems to protect your business data.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Network Security</div>
                    <ul className="popover-list">
                      <li>Next‑gen firewall deployment and policies</li>
                      <li>Site‑to‑site and remote‑access VPNs</li>
                      <li>IDS/IPS, threat feeds and geolocation blocks</li>
                      <li>Zero‑trust segmentation and NAC</li>
                      <li>Logging, SIEM forwarding and alerts</li>
                      <li>Security posture review and hardening</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">⚡</div>
                    <h3>Performance Optimization</h3>
                  </div>
                  <p>Network analysis and optimization to ensure maximum speed and reliability for your business operations.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Performance Optimization</div>
                    <ul className="popover-list">
                      <li>Throughput and latency benchmarking</li>
                      <li>QoS shaping and traffic prioritization</li>
                      <li>LAN/WAN path analysis and MTU tuning</li>
                      <li>Duplex, errors and retransmit remediation</li>
                      <li>Monitoring dashboards and baselining</li>
                      <li>Capacity planning and scaling roadmap</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Why Choose Our Network Services?</h2>
                <ul className="benefits-list">
                  <li>✓ Network certified engineers</li>
                  <li>✓ Scalable solutions for businesses of all sizes</li>
                  <li>✓ 98% uptime guarantee with SLA</li>
                  <li>✓ 8 X 6 network monitoring and support</li>
                  <li>✓ Advanced security implementations</li>
                  <li>✓ Comprehensive documentation and training</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Setup Time:</span>
                  <span className="highlight-value">1-3 Days</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Uptime SLA:</span>
                  <span className="highlight-value">98%</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Support:</span>
                  <span className="highlight-value">8 X 6</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Certification:</span>
                  <span className="highlight-value">CCNA</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default NetworkSetup;
